import MDBox from "../../../components/MDBox";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDTypography from "../../../components/MDTypography";
import {
    Alert,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControl, InputAdornment, Paper, Popper,
    Skeleton
} from "@mui/material";
import MDInput from "../../../components/MDInput";
import Autocomplete from "@mui/material/Autocomplete";
import Button from "@mui/material/Button";
import {MuiDataGrid} from "../../../components/MuiDatagrid";
import {
    GridToolbar,
    GridToolbarColumnsButton,
    GridToolbarContainer,
    GridToolbarDensitySelector, GridToolbarExport,
    GridToolbarFilterButton
} from "@mui/x-data-grid";
import { zhCN,enUS } from '@mui/x-data-grid/locales';
import moment from "moment";
import CustomerEditor from "../CustomerEditor";
import MDButton from "../../../components/MDButton"
import LocalStorage from "../../../utils/LocalStorage";
import {removeCustomer} from "../../../actions/customer/customerAction";
import {
    change_Customer_Active,
    customerFilter,
    InventoryActionType,
    ownerSelected, packagingFilter
} from "../../../actions/inventory/inventoryAction";
import Fade from "@mui/material/Fade";
import React, {memo, useEffect, useRef, useState} from "react";
import {Trans, useTranslation} from "react-i18next";
import {useDebounce} from "use-debounce";
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {Logout, onErrorAlert, onSuccessAlert, requisitionFilter} from "../../../actions";
import {isEqual, noop} from "lodash";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import { v4 as uuidv4 } from 'uuid';
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import {checkPermission, PERMISSION_DICT} from "../../../utils/Users_Roles_Permission";
import {COLUMN_WIDTH} from "../../../constants";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CurrentStateLoading from "../../../examples/Loading/CurrentStateLoading";
import {MaterialReactTable, useMaterialReactTable} from "material-react-table";
import {download, generateCsv, mkConfig} from "export-to-csv";
import DownloadIcon from "@mui/icons-material/Download";
import {MRT_Localization_EN} from "material-react-table/locales/en";
import {MRT_Localization_ZH_HANS} from "material-react-table/locales/zh-Hans";
import {MRT_Localization_FR} from "material-react-table/locales/fr";
import ClearIcon from "@mui/icons-material/Clear";
import Tour from "reactour";
import HelpIcon from "@mui/icons-material/Help";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import CustomerImportDialog from "../CustomerImportDialog";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

const OwnerCustomer = memo(() => {

    const {t, i18n} = useTranslation();
    const [condition, setCondition] = useState('')
    const [isActive, setIsActive] = useState(null)
    const [loading, setLoading] = useState(false)
    const [value] = useDebounce(condition, 800);
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 50, //customize the default page size
    });
    const [rowSelection, setRowSelection] = useState({});
    const nav = useNavigate()
    const dispatch = useDispatch()
    const languageSelect = useSelector(state => state?.common?.language,(prev, next) => prev === next)
    const [total,setTotal] = useState(0)
    const [data,setData] = useState([])
    const [isOpen, setIsOpen] = useState(false)
    const [transferData, setTransferData] = useState({})
    const [type, setType] = useState('Add')
    const [currentRow,setCurrentRow] = useState({})
    const [isAlertOpen, setIsAlertOpen] = useState(false)
    const [ownerList ,setOwnerList] =useState([])
    const [owner,setOwner] = useState([])
    const [inputOwnerValue,setInputOwnerValue] = useState()
    const [ownerValue] = useDebounce(inputOwnerValue, 500);
    const [triggerFetch, setTriggerFetch] = useState(false);
    const lastPayloadRef = React.useRef(null);
    const initialLoad = React.useRef(true);
    const col = { left: ['mrt-row-select','mrt-row-numbers','ownerId' ,'customerName','mrt-row-actions'] , right: ['activeAction']}
    const mobileCol = { left: ['mrt-row-numbers','mrt-row-actions'] }
    const mdCol = {  left: ['mrt-row-numbers','customerName','mrt-row-actions']}
    const [exportLoading,setExportLoading] = useState(false)

    const [dragState, setDragState] = useState({
        isDragging: false,
        startCell: null,
        endCell: null,
    });
    const [tourOpen,setTourOpen] = useState(false)
    const [currentStep, setCurrentStep] = useState(0);
    const [cellClicked, setCellClicked] = useState({first:null,last:null});
    const [isCopyOpen,setIsCopyOpen] = useState(false)
    const [preloaded, setPreloaded] = useState(false);

    const [skuList,setSkuList] = useState('')
    const [skusInput,setSkusInput] = useState('')
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [open, setOpen] = React.useState(false);
    const [errors,setErrors] = useState({error:false,message:''})
    const [popperValue] = useDebounce(skuList, 400);

    const PAGE_KEY = 'customer-owners-customer'
    const MOBILE_WIDTH = 600;
    const TABLET_WIDTH = 960;
    const getStoredColumnPinning = () => {
        const storedData = JSON.parse(localStorage.getItem("columnPinning")) || {};
        return storedData[PAGE_KEY] || null;
    };

    const [columnPinning, setColumnPinning] = useState(() => {
        const storedValue = getStoredColumnPinning();
        if (storedValue) return storedValue;

        // 按照默认逻辑走
        const width = window.innerWidth;
        if (width < MOBILE_WIDTH) return mobileCol;
        if (width < TABLET_WIDTH) return mdCol;
        return col;
    });

    useEffect(() => {
        const storedData = JSON.parse(localStorage.getItem("columnPinning")) || {};
        if (JSON.stringify(storedData[PAGE_KEY]) !== JSON.stringify(columnPinning)) {
            storedData[PAGE_KEY] = columnPinning;
            localStorage.setItem("columnPinning", JSON.stringify(storedData));
        }
    }, [columnPinning]);
    const [columnVisibility, setColumnVisibility] = useState(() => {
        const storedData = JSON.parse(localStorage.getItem('columnVisibility')) || {};
        return storedData[PAGE_KEY] || {
            customerStyleCode: false,
            openCreditState:false,
        }; // 读取当前页面的列可见性
    })

    useEffect(() => {
        // 每次用户更改列显示状态时，存储到 localStorage
        const storedData = JSON.parse(localStorage.getItem('columnVisibility')) || {};
        storedData[PAGE_KEY] = columnVisibility; // 更新当前页面的列可见性
        localStorage.setItem('columnVisibility', JSON.stringify(storedData));
    }, [columnVisibility]);

    const headerRef = useRef(null);
    const [tableHeight, setTableHeight] = useState(640);

    useEffect(() => {
        const updateTableHeight = () => {
            if (headerRef.current) {
                const headerTop = headerRef.current.getBoundingClientRect().top;
                const newHeight = window.innerHeight - headerTop - 90;
                setTableHeight(newHeight > 200 ? newHeight : 200);
            }
        };

        const resizeObserver = new ResizeObserver(updateTableHeight);
        if (headerRef.current) {
            resizeObserver.observe(headerRef.current);
        }

        updateTableHeight(); // 初始化计算

        return () => resizeObserver.disconnect();
    }, []);


    useEffect(() => {
        if(!isAlertOpen){
            setType('Add')
        }
    }, [isAlertOpen]);

    useEffect(() => {
        if(skuList !== ''){

            let lines = skuList.split('\n')

            let skus =  lines.filter(v=> v!=='')
            if(skus.length > 200){
                setErrors({ error: true, message: `${t('CustomerPage.You Already input')} ${skus.length} ${t('CustomerPage.Customer Names, The Input Cannot Exceed 200 customer names')}` })
            } else {
                setErrors({ error: false, message: '' })
            }
        }

    }, [popperValue]);


    const steps = [
        {
            selector: '[data-tut="reactour_start"]',
            content: () => (
                <div>
                    <Trans i18nKey="PressFirstRowCopyCustomerName">
                        Press <strong>Shift</strong> and click the cell to select the first row to copy.
                    </Trans>
                </div>
            ),
        },
        {
            selector: '[data-tut="reactour_end"]',
            content: () => (
                <ul>
                    <li>
                        <Trans i18nKey="ReleaseLastRowCopyCustomerName">
                            Press <strong>Shift</strong> and click the cell to select the last row to copy
                        </Trans>
                    </li>
                    <li>
                        <Trans i18nKey="SelectedCustomerNameYellowBorder"
                               components={{
                                   span: <span style={{ color: '#FFA726' }} />,
                                   strong: <strong />
                               }}
                        >
                            <strong>Double Click</strong> any <span>Yellow</span> border cell to copy the batch
                        </Trans>
                    </li></ul>
            ),
        },
        {
            selector: '[data-tut="reactour_step3"]',
            content: () => (
                <ul>
                    <li>
                        <Trans
                            i18nKey="PasteBatchCustomerNames"
                            components={{
                                strong: <strong />
                            }}
                        >
                            <strong>Paste</strong> the batch SKUs into the input field
                        </Trans></li>
                    <li>
                        <Trans
                            i18nKey="ClipboardToExcel"
                            components={{
                                strong: <strong />
                            }}
                        >
                            <strong>Paste</strong> the batch SKUs into the input field
                        </Trans></li>
                </ul>
            ),

        },
        {
            selector: '[data-tut="reactour_step4"]',
            content: () => (
                <ul>
                    <li>
                        <Trans
                            i18nKey="FilterDownCopyCustomerNames"
                            components={{
                                strong: <strong />
                            }}
                        >
                            <strong>Paste</strong> the batch SKUs into the input field
                        </Trans></li>
                </ul>
            ),
        }
    ];

    useEffect(() => {
        document?.getElementById('sku_popper')?.focus()
        if(skusInput !==''){
            const str  = skusInput.split(",").map(sub=>sub.trim()).join("\n")
            setSkuList(str)
        } else {
            setSkuList('')
        }
        if(!open){
            setErrors({error:false,message:''})
        }
    }, [open]);

    useEffect(()=>{
        if(currentStep === 1){
            setIsCopyOpen(true)
            setDragState({
                isDragging: false,
                startCell: {row:{index:0}},
                endCell: {row:{index:4}}
            })
        }

        if(currentStep === 3){
            const startRowIndex = Math.min(dragState?.startCell?.row.index, dragState?.endCell?.row.index);
            const endRowIndex = Math.max(dragState?.startCell?.row.index, dragState?.endCell?.row.index);


            const kitSkuData = data.slice(startRowIndex, endRowIndex + 1)
                .map(row => row['customerName'])  // 假设'kitSku'是数据对象中对应列的键
                .join('\n');  // 使用换行符分隔，以便在复制到Excel等表格应用时形成单列

            let lines = kitSkuData.split('\n')
            let skus =  lines.filter(v=> v!=='')
            let jointString = skus.join(",")

            //     dispatch(onErrorAlert('The Input Cannot Exceed 200 SKUs'))

            setSkusInput(jointString)

            // 复制到剪切板
            navigator.clipboard.writeText(kitSkuData)
                .then(() => dispatch(onSuccessAlert(t('CustomerPage.Customer Name copied to clipboard'))))
                .catch(err => dispatch(onErrorAlert((`${t('CustomerPage.Failed to copy data')}: ${err}`))));
            setIsCopyOpen(false)
            setDragState({
                isDragging: false,
                startCell: null,
                endCell: null,
            })
        }
    },[currentStep])

    const handleSyncPopper = () => {
        let lines = skuList.split('\n')
        let skus =  lines.filter(v=> v!=='')
        let jointString = skus.join(",")
        if(errors.error){
            dispatch(onErrorAlert(t('CustomerPage.The Input Cannot Exceed 200 Customer Names')))
        } else {
            setSkusInput(jointString)
            setOpen(false)
        }
    }
    const skusPoppers = () => (
        <MDBox
            sx={{width:350}}
            role="presentation"
            display={'flex'}
            flexDirection={'column'}
            px={3}
            pb={3}
            justifyContent={'center'}
        >
            <Alert severity="info"
                   sx={{wordWrap:'break_word',whiteSpace:'normal',fontSize:'small',fontWeight:'medium'}}
            >
                {t("CustomerPage.Please enter the customer names in the input field below.Each customer name should be entered on a separate line")}

            </Alert>

            <MDBox pt={1} pb={0} px={3} sx={{display: 'flex', justifyContent: 'space-between'}}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={12} mb={2} sx={{minWidth: 250}}>
                        <FormControl
                            fullWidth
                            error={!!errors.error}
                        >
                            <MDInput
                                sx={{whiteSpace: "pre-wrap",overflowX:'auto','& textarea':{overflow:'auto'}}}
                                label={t('CustomerPage.Enter Customer Names, One Per Line')}
                                fullWidth
                                multiline
                                autoFocus={true}
                                variant="standard"
                                required
                                maxRows={5}
                                minLength={300}
                                InputLabelProps={{shrink: true}}
                                value={skuList}
                                onChange={(e) => setSkuList(e.target.value)}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position='end'>
                                            <IconButton
                                                size={'small'}
                                                aria-label='toggle password visibility'
                                                onClick={()=>{
                                                    setSkuList('')
                                                    setErrors({error: false,message:''})
                                                }}
                                                onMouseDown={()=>{
                                                    setSkuList('')
                                                    setErrors({error: false,message:''})
                                                }}>
                                                <ClearIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                            {errors?.error &&
                                <FormHelperText
                                    sx={{fontWeight: 'medium'}}>{errors?.message}
                                </FormHelperText>
                            }
                        </FormControl>

                    </Grid>
                </Grid>
            </MDBox>
            <MDBox display={'flex'} justifyContent={'flex-end'}>

                <MDButton size={'small'} variant={'outlined'} color="primary"  onClick={()=>setOpen(false)} >
                    {t('Close')}
                </MDButton>
                <MDButton size={'small'} variant={'gradient'} color="info"  onClick={handleSyncPopper} >
                    {t('Enter')}
                </MDButton>
            </MDBox>
        </MDBox>
    );

    const closeTour = () => {
        setTourOpen(false);
        setCurrentStep(0); // 关闭时重置为第一步
        setSkusInput('')
        LocalStorage.setItem('batch_guide','done')
    };


    const openTour = () => {
        setCurrentStep(0); // 每次打开时从第一步开始
        setTourOpen(true);
        setPreloaded(true);
    };

    const [isImportOpen,setIsImportOpen] = React.useState(false)



    useEffect(() => {
        if(type === 'Open'){
            const axiosPost = async () => {

                await dispatch(change_Customer_Active(
                    {
                        customer: {customerId:currentRow.customerId,
                            customerName:currentRow.customerName,
                            isActive:'Y',
                            ownerId:currentRow.ownerId,
                            userName:currentRow.ownerName}
                    },
                    onUpdateSuccess, onError))
            }
            axiosPost().then()


        }


    }, [currentRow]);
    const activeArr = [
        {
            id: 1,
            value: 'Y',
            label: `${t(`ProductPage.OPEN`)}`
        },
        {
            id: 2,
            value: 'N',
            label: `${t(`ProductPage.CLOSED`)}`
        },
        {
            id: 3,
            value: 'C',
            label: `${t(`ProductPage.CREATED`)}`
        },

    ]

    const handleCellCopyClick = (text) => {
        const textToCopy = text
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(textToCopy)
                .then(() => {
                    dispatch(onSuccessAlert(`"${textToCopy}" ${t('copied')}`))
                })
                .catch((err) => {
                    dispatch(onErrorAlert(`${t('copy failed')}`))
                });
        }

    };

    const columns = [
        {
            accessorKey: 'ownerId',
            header: t('ownerId'),
            size: COLUMN_WIDTH.ownerId,
            muiTableBodyCellProps: ({ cell }) => ({
                onDoubleClick: (event) => {
                    handleCellCopyClick(cell.getValue())
                },
            }),
        },

        {
            accessorKey: 'ownerName',
            header: t('ownerName'),
            size:  COLUMN_WIDTH.ownerName,
            muiTableBodyCellProps: ({ cell }) => ({
                onDoubleClick: (event) => {
                    handleCellCopyClick(cell.getValue())
                },
            }),

        },
        {
            accessorKey: 'customerId',
            header: t('CustomerPage.Customer ID'),
            size: 200,
            muiTableBodyCellProps: ({ cell }) => ({
                onDoubleClick: (event) => {
                    handleCellCopyClick(cell.getValue())
                },
            }),
        },
        {
            accessorKey: 'customerName',
            header: t('CustomerPage.Customer Name'),
            size: 250,
            muiTableBodyCellProps: ({ row, cell }) => {

                let dataTutAttr = {};
                // 判断 data.length 是否大于等于 5，如果是，才添加 `data-tut` 属性
                if (data.length >= 5) {
                    if (row.index === 0) {
                        dataTutAttr = { 'data-tut': 'reactour_start' };
                    } else if (row.index === 4) {
                        dataTutAttr = { 'data-tut': 'reactour_end' };
                    }
                }
                const additionalClassName = row.index >= 0 && row.index <= 5 ? 'reactour_range' : '';

                return {
                    ...dataTutAttr,
                    className: additionalClassName,
                    sx: {
                        borderColor: (cell.column.id === 'customerName' &&
                            cell.row.index >= (dragState.startCell ? dragState.startCell.row.index : -1) &&
                            cell.row.index <= (dragState.endCell ? dragState.endCell.row.index : -1))  ? {
                            borderColor: '#FFA726 !important',
                        } : {},
                        height:'30px'
                    },
                    onDoubleClick: (event) => {
                        handleCellCopyClick(cell.getValue())
                    },
                    onMouseDown: (event) => onCellMouseDown(event,cell),
                    onMouseEnter: (event) => onCellMouseEnter(event,cell),
                    onMouseUp: (event) => onCellMouseUp(event),
                }

            },
        },
        {
            accessorKey: 'isActive',
            header: t('ProductPage.isActive'),
            size: 130,
            Cell: ({cell}) => (
                <div>
                    {activeArr.find(v => v.value === cell.getValue())?.label}
                </div>
            )

        },
        {
            accessorKey: 'customerStyleCode',
            header: t('CustomerPage.Customer Style Code'),
            size: 300,
            muiTableBodyCellProps: ({ cell }) => ({
                onDoubleClick: (event) => {
                    handleCellCopyClick(cell.getValue())
                },
            }),
        },
        {
            accessorKey: 'openCreditState',
            header: t('CustomerPage.Open Credit State'),
            size: 300,
            muiTableBodyCellProps: ({ cell }) => ({
                onDoubleClick: (event) => {
                    handleCellCopyClick(cell.getValue())
                },
            }),
        },
        ...(checkPermission(PERMISSION_DICT.OwnerCustomerModify) ? [
            {
                accessorKey: 'activeAction',
                header: t('activeAction'),
                size: 130,
                enableSorting:false,
                Cell: ({row}) => (
                    <MDBox sx={{display:'flex',justifyContent:'space-between'}}>
                        <IconButton color="success"
                                    disabled={row.original.isActive === 'Y' || !checkPermission(PERMISSION_DICT.OwnerCustomerModify)}
                                    onClick={()=>{
                                        setCurrentRow(row.original)
                                        setType('Open')
                                    }}
                        >
                            <Tooltip title={t('open')}><Icon>toggle_on</Icon></Tooltip>
                        </IconButton>

                        <IconButton color="error"
                                    disabled={row.original.isActive === 'N' || !checkPermission(PERMISSION_DICT.OwnerCustomerModify)}
                                    onClick={()=>{
                                        setCurrentRow(row.original)
                                        setType('Close')
                                        setIsAlertOpen(true)
                                    }
                                    }
                        >
                            <Tooltip title={t('close')}><Icon>toggle_off</Icon></Tooltip>
                        </IconButton>

                    </MDBox>
                ),

            },
        ]:[])

    ]

    const onCellMouseDown = (event,cell) => {

        event.stopPropagation();
        event.preventDefault();
        if (cell.column.id === 'customerName') {
            setDragState({
                isDragging: true,
                startCell: cell,
                endCell: null,
            });
        }
    };

    const onCellMouseEnter = (event,cell) => {
        event.stopPropagation();
        event.preventDefault();
        if (dragState.isDragging && cell.column.id === dragState.startCell.column.id) {
            setDragState({
                ...dragState,
                endCell: cell,
            });
        }
    };

    const onCellMouseUp = (event) => {
        event.stopPropagation();  // 阻止事件冒泡
        event.preventDefault();
        let { startCell, endCell } = dragState;
        if (startCell && endCell && startCell.column.id === endCell.column.id) {
            if (startCell.row.index > endCell.row.index) {
                // 如果起始行大于结束行，交换它们
                [startCell, endCell] = [endCell, startCell];
            }

        }

        // 更新状态，结束拖拽
        setDragState({
            isDragging: false,
            startCell,
            endCell
        });
    };


    useEffect(() => {

        if(!dragState.isDragging && dragState.startCell && dragState.endCell){
            setIsCopyOpen(true)
        }
    }, [dragState]);


    const handleReset = () => {
        setOwner([])
        setIsActive(null)
        setCondition('')
        setPagination((prev) => ({ ...prev, pageIndex: 0 }));
        setTriggerFetch((prev) => !prev);
        setSkusInput('')
    }

    const onUpdateSuccess = (msg) => {
        dispatch(onSuccessAlert(`${t('open')} ${msg} ${t('CustomerPage.Customer Successfully')}`))
        let formData = {}
        if (saveFormData()) {
            formData = saveFormData()
        } else {
            return nav('/')
        }


        const axiosPost = async () => {

            setLoading(true)
            await dispatch(customerFilter(formData, onSearchSuccess, onError))
        }
        axiosPost().then()
    }

    useEffect(() => {
        return () => {
            setTotal(0)
            setData([])
            setTriggerFetch(false)
            lastPayloadRef.current = null
            initialLoad.current = true
        };
    }, [dispatch]);

    const onCloseSuccess = (msg) => {
        dispatch(onSuccessAlert(`${t(`Close`)} ${msg} ${t(`successfully`)}`))
        setIsAlertOpen(false)

        let formData = {}
        if (saveFormData()) {
            formData = saveFormData()
        } else {
            return nav('/')
        }


        const axiosPost = async () => {

            setLoading(true)
            await dispatch(customerFilter(formData, onSearchSuccess, onError))
        }
        axiosPost().then()
    }

    const handleOnFocusClick = (event) => {
        if( LocalStorage.getItem('batch_guide') && LocalStorage.getItem('batch_guide') === 'done'){
            setAnchorEl(event.currentTarget);
            setOpen((prev) => true);
            document.getElementById('sku_popper')?.focus()
        } else {
            setTourOpen(true)
        }


    };

    const saveFormData = () => {
        let formData = {}
        formData.isActive = isActive ? isActive.value : ''
        formData.condition = value
        formData.pageNum = (pagination.pageIndex + 1)
        formData.pageSize = pagination.pageSize
        formData.language = languageSelect
        formData.customerNames = skusInput === ''?[]: skusInput.split(",").map(sub=>sub.trim())
        if(checkPermission(PERMISSION_DICT.QueryOwnerInfo)){
            formData.ownerIds = []
        }
        if(owner && owner?.length > 0 && checkPermission(PERMISSION_DICT.QueryOwnerInfo)){
            owner.forEach(v=>{
                formData.ownerIds.push(v.ownerId)
            })
        }

        if (LocalStorage.getItem('username')) {
            formData.userName = LocalStorage.getItem('username')
        } else {
            return null
        }

        return formData
    }

    useEffect(()=>{


        if(ownerValue){
            const axiosPost = async () => {
                await dispatch(ownerSelected({condition: ownerValue, userName: LocalStorage.getItem('username')}, (data)=>setOwnerList(data)))
            }
            axiosPost().then()
        } else {
            setOwnerList([])
        }
    },[ownerValue])

    const onError = (msg, code) => {
        dispatch(onErrorAlert(msg))
        setExportLoading(false)
        setLoading(false)
        if (code === 401) {
            dispatch(Logout(noop))
            nav('/')
        }
    }

    const onSearchSuccess = (data) => {
        setTotal(data?.total ? data?.total:0)
        setData(data?.rows ? data?.rows.map((item, index) => {
            return { ...item, id: uuidv4() };
        }):[])
        setLoading(false)


    }



    useEffect(() => {
        let formData = {}
        if (saveFormData()) {
            formData = saveFormData()
        } else {
            return nav('/')
        }

        if(initialLoad.current){
            const axiosPost = async () => {

                checkPermission(PERMISSION_DICT.OwnerCustomerList) && setLoading(true)
               !loading && await dispatch(customerFilter(formData, onSearchSuccess, onError))
            }
            axiosPost().then()
            initialLoad.current = false
        } else if (isEqual(lastPayloadRef.current, formData) && !initialLoad.current) {
            return; // 如果 payload 相同，跳过请求
        } else {
            const axiosPost = async () => {

                checkPermission(PERMISSION_DICT.OwnerCustomerList) && setLoading(true)
                !loading && await dispatch(customerFilter(formData, onSearchSuccess, onError))
            }
            axiosPost().then()
            initialLoad.current = false
        }

        // 如果不同，更新 lastPayloadRef 并发送请求
        lastPayloadRef.current = formData;

    }, [pagination.pageIndex, pagination.pageSize, triggerFetch,languageSelect]);

    useEffect(() => {

        setPagination((prev) => ({ ...prev, pageIndex: 0 }));
        setTriggerFetch((prev) => !prev);
    }, [isActive, value, owner,skusInput]);


    const csvConfig = mkConfig({
        fieldSeparator: ',',
        decimalSeparator: '.',
        useKeysAsHeaders: false,
        filename:`Owner_Customer_Information_${moment().format('YYYYMMDD')}`,
        columnHeaders: columns.map(({ accessorKey, header }) => ({
            key: accessorKey,
            displayLabel: header,
        }))

    });

    function CustomerToolbar() {

        const onLoadingClick = () => {
            const axiosPost = async () => {
                setLoading(true)
                await dispatch(customerFilter(saveFormData(),onSearchSuccess,onError))
            }
            axiosPost().then()
        }

        const handleClick = async () => {
            setExportLoading(true)
            const rowData = data.filter(object=>Object.keys(rowSelection).filter(key => rowSelection[key]).includes(object?.id))
            const csv = generateCsv(csvConfig)(rowData.map(({ id, ...item }) =>({
                ...item,
            })));
            download(csvConfig)(csv);
            setExportLoading(false)
            dispatch(onSuccessAlert(`${t('Export')} Owner_Customer_Information_${moment().format('YYYYMMDD')} ${t('Successfully')}`))
        }
        return (
            <MDBox sx={{display:'flex',flexWrap:'wrap',maxWidth:'100%'}}>

                {checkPermission(PERMISSION_DICT.OwnerCustomerAdd) &&
                        <MDButton
                            data-test="customer-add-btn"
                            startIcon={<AddCircleOutlineIcon/>}
                            color={'info'}
                            variant={'text'}
                            onClick={() => setIsOpen(true)}
                            // disabled={loading || !haveCard}
                        >
                            {t('ProductPage.Add')}
                        </MDButton>
                }

                <MDButton variant={'text'} color="info" startIcon={<DownloadIcon/>} onClick={handleClick} disabled={data.filter(object=>Object.keys(rowSelection).filter(key => rowSelection[key]).includes(object?.id)).length === 0}>
                    {t('export')}
                </MDButton>
                {
                    checkPermission(PERMISSION_DICT.OwnerCustomerBatchImport) &&
                    <MDButton
                        startIcon={<CloudUploadIcon/>}
                        color="info"
                        variant={'text'}
                        disabled={loading}
                        onClick={() => setIsImportOpen(true)}
                    >
                        {t("csvUpload")}
                    </MDButton>
                }
                <CurrentStateLoading onLoadingClick={onLoadingClick} loading={loading}/>
                <MDButton variant={'text'} color="info" startIcon={<HelpOutlineIcon/>} onClick={openTour} disabled={data.length<6}>
                    {t('help')}
                </MDButton>
            </MDBox>
        );
    }

    useEffect(() => {
        if(loading){
            setRowSelection({})
        }
    }, [loading]);

    const table = useMaterialReactTable({
        enableColumnActions: false,
        columns,
        data,
        enableSorting: true,
        enableColumnPinning: true,
        onColumnPinningChange:setColumnPinning,
        getRowId: (row) => (row.id),
        enableRowSelection: true,
        enableRowActions: true,
        displayColumnDefOptions: {
            'mrt-row-actions': {
                size: 60, //if using layoutMode that is not 'semantic', the columns will not auto-size, so you need to set the size manually
                grow: false,
            },
        },
        positionActionsColumn: 'last',
        renderRowActions: ({ row }) => (
            <MDBox sx={{ display: 'flex', flexWrap: 'nowrap' }} >
                <IconButton
                    data-test="action-button"
                    color="primary"
                    disabled={!checkPermission(PERMISSION_DICT.OwnerCustomerInfo)}
                    onClick={() => {
                        setTransferData(row.original);
                        setType('Preview');
                        setIsOpen(true)
                    }}>
                    <Icon>preview</Icon>
                </IconButton>
            </MDBox>

        ),
        enableRowNumbers: true,
        rowNumberDisplayMode: 'static',
        rowCount:total,
        paginationDisplayMode: 'pages',
        positionToolbarAlertBanner: 'bottom',
        enableColumnResizing: true,
        localization:languageSelect === 'en'?MRT_Localization_EN:languageSelect === 'zh'?MRT_Localization_ZH_HANS:MRT_Localization_FR,
        enableStickyHeader: true,
        enableStickyFooter: true,
        manualPagination: true,
        enableDensityToggle: false,
        enableBatchRowSelection: true,
        initialState: {
            density: 'compact',
            // columnVisibility: {
            //     customerStyleCode: false,
            //     openCreditState:false,
            // },
        },
        onPaginationChange:setPagination,
        state: {
            pagination,
            rowSelection,
            isLoading:loading,
            showLoadingOverlay:false,
            showSkeletons:loading,
            showAlertBanner:false,
            columnPinning,
            columnVisibility
        },
        onColumnVisibilityChange:setColumnVisibility,
        onRowSelectionChange:setRowSelection,
        muiPaginationProps: {
            rowsPerPageOptions: [50, 100, 200],
            showFirstButton: true,
            showLastButton: true,
            color: 'primary',
            shape: 'rounded',
            showRowsPerPage: true,
            size:'small',
        },
        muiTableBodyCellProps:({ table }) => ({

            sx: (theme) => ({
                height:'30px',
            }),
            onClick: (event) => { event.preventDefault();}
        }),
        muiTableContainerProps: ({ table }) => ({
            sx: {
                maxHeight: table.getState().isFullScreen ?  undefined:tableHeight,
            },
        }),
        renderTopToolbarCustomActions: CustomerToolbar,
        muiTopToolbarProps:{
            sx: (theme) => ({
                maxWidth:'100%',
                background: theme.palette.background.table,
                padding:'0px',
                '& > div': {
                    padding: '0px',
                },
                '& > div:nth-of-type(2)': {
                    display:'flex',
                    flexWrap:'wrap'
                },
            }),
        },
        muiBottomToolbarProps:{sx: (theme) => ({backgroundColor:`${theme.palette.background.card} !important`})},
        muiTablePaperProps:{sx:
                {
                    boxShadow:'none',
                    '& > div:nth-of-type(1)': {
                        minHeight: '0', // 或者 'auto'
                    },
                }
        },
        muiSearchTextFieldProps:{
            placeholder: 'Search current page...',
        }



    });

    return (<React.Fragment>
        <Fade in={true} mountOnEnter unmountOnExit >
            <MDBox pt={2} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>

                            <MDBox sx={{display: 'flex', justifyContent: 'center',overflow: 'auto'}}>
                                <Grid container xs={12} px={4} pt={0} spacing={2} alignItems={'flex-end'}>
                                {
                                    checkPermission(PERMISSION_DICT.QueryOwnerInfo) &&
                                    <Grid item xs={12} md={3} >
                                        <MDBox>
                                            <FormControl fullWidth >
                                                <Autocomplete
                                                    multiple
                                                    sx={{'& .MuiAutocomplete-inputRoot':{padding:0.05}}}
                                                    id="tags-standard"
                                                    options={ownerList}
                                                    getOptionLabel={(option) => `ID: ${option?.ownerId} Name: ${option?.ownerName}`}
                                                    isOptionEqualToValue={(option, value) => option?.ownerId === value?.ownerId}
                                                    value={owner}
                                                    onChange={(e, v) => setOwner(v)}
                                                    onInputChange = {(event, newInputValue)=> setInputOwnerValue(newInputValue)}
                                                    renderInput={(params) => (
                                                        <MDInput
                                                            {...params}
                                                            label={t("Owner ID or Name")}
                                                            variant={'standard'}
                                                        />
                                                    )}
                                                    noOptionsText={t('No Options')}
                                                />
                                            </FormControl>
                                        </MDBox>
                                    </Grid>
                                }
                                <Grid item xs={12} md={2} >
                                    <MDBox>
                                        <FormControl fullWidth >
                                            <MDInput
                                                label= {t("CustomerPage.Search by customer ID or Name")}
                                                value={condition}
                                                onChange={(e) => setCondition(e.target.value)}
                                                variant={'standard'}
                                            />
                                        </FormControl>
                                    </MDBox>
                                </Grid>
                                    <Grid item xs={12} md={3}>
                                        <MDBox>
                                            <FormControl fullWidth
                                                         sx={(theme) => ( {"& .MuiTextField-root":{backgroundColor:'rgba(0,0,0,0)'}})}
                                            >
                                                <MDInput
                                                    label={t('CustomerPage.Enter Batch Customer Name')}
                                                    value={skusInput}
                                                    onChange={(e) => setSkusInput(e.target.value)}
                                                    variant={'standard'}
                                                    disabled={open}
                                                    InputProps={{
                                                        endAdornment:
                                                            <InputAdornment position="end">
                                                                <Tooltip title={t('ProductPage.Click to display guide')}>
                                                                    <IconButton
                                                                        size={'small'}
                                                                        disabled={loading}
                                                                        aria-label="Click to display guide"
                                                                        onClick={()=> setTourOpen(true)}
                                                                        edge="end"
                                                                    >
                                                                        { <HelpIcon />}
                                                                    </IconButton>
                                                                </Tooltip>

                                                            </InputAdornment>,
                                                        onFocus: handleOnFocusClick,
                                                        inputProps: {
                                                            'data-tut': 'reactour_step4', // 添加 data-tut 属性
                                                        },
                                                    }}
                                                />
                                                <Popper
                                                    // Note: The following zIndex style is specifically for documentation purposes and may not be necessary in your application.
                                                    sx={{ zIndex: 1200 }}
                                                    open={open}
                                                    disablePortal={false}
                                                    anchorEl={anchorEl}
                                                    placement={'top-end'}
                                                    transition
                                                    modifiers={[
                                                        {
                                                            name: 'flip',
                                                            enabled: true,
                                                            options: {
                                                                altBoundary: true,
                                                                rootBoundary: 'document',
                                                                padding: 8,
                                                            },
                                                        },
                                                        {
                                                            name: 'preventOverflow',
                                                            enabled: true,
                                                            options: {
                                                                altAxis: true,
                                                                altBoundary: true,
                                                                tether: true,
                                                                rootBoundary: 'document',
                                                                padding: 8,
                                                            },
                                                        },

                                                    ]}
                                                >
                                                    {({ TransitionProps }) => (
                                                        <Fade {...TransitionProps} timeout={200}>
                                                            <Paper>
                                                                <MDBox sx={{display:'flex', justifyContent:'flex-end'}}>
                                                                    <IconButton size="large" onClick={() => setOpen(false)}>
                                                                        <Icon>cancel</Icon>
                                                                    </IconButton>
                                                                </MDBox>
                                                                {skusPoppers()}
                                                            </Paper>
                                                        </Fade>
                                                    )}
                                                </Popper>
                                            </FormControl>
                                        </MDBox>
                                    </Grid>
                                <Grid item xs={12} md={2} >
                                    <MDBox>
                                        <FormControl fullWidth >
                                            <Autocomplete
                                                required
                                                disablePortal={false}
                                                options={activeArr}
                                                sx={{'& .MuiAutocomplete-inputRoot':{padding:0.05}}}
                                                getOptionLabel={(option) => `${option?.label}`}
                                                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                                value={isActive}
                                                onChange={(e, v) => setIsActive(v)}
                                                renderInput={(params) =>
                                                    <MDInput
                                                        {...params}
                                                        label={t("ProductPage.Active")}
                                                        variant={'standard'}
                                                    />}
                                            />
                                        </FormControl>
                                    </MDBox>
                                </Grid>
                                    <Grid item xs={6} md={1.5} sx={{display:'flex',justifyContent:{xs: 'start', md: 'start'}}}>
                                        <MDButton sx={{marginLeft:1}} size={'small'} color="secondary" variant="outlined" startIcon={<CleaningServicesIcon />} onClick = {handleReset}>
                                            {t('reset')}
                                        </MDButton>
                                    </Grid>
                                </Grid>
                            </MDBox>
                            <MDBox pb={0} mt={0} px={4} ref={headerRef}>
                                <MaterialReactTable table={table} />
                            </MDBox>

                            <CustomerEditor isOpen={isOpen} setIsOpen={setIsOpen} type={type} setType={setType} data={transferData} setTransferData={setTransferData} pageFormData={saveFormData()} pageLoading={loading} setPageLoading={setLoading} setTotal={setTotal} setList={setData}/>
                            <Dialog
                                open={isAlertOpen}
                                onClose={() => setIsAlertOpen(false)}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                                fullWidth
                                maxWidth={'sm'}
                            >
                                <DialogTitle id="alert-dialog-title">
                                    <div>{t("Are you sure?")}</div>
                                </DialogTitle>
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        {`${t('CustomerPage.Do you really want to')} ${t(`${type.toLowerCase()}`)} ${t('CustomerPage.customer')}:`}
                                        <span style={{color: 'red', padding: '10px', fontWeight: 'bold'}}>{currentRow.customerId}</span>
                                        ?
                                        {/*{t('This process cannot be undone')}*/}
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <MDButton onClick={() => setIsAlertOpen(false)}>{t('Disagree')}</MDButton>
                                    <MDButton onClick={async () => {
                                        let formData = {}
                                        formData.userName = currentRow.ownerName
                                        formData.customerId = currentRow.customerId

                                        // if(type === 'Delete'){
                                        //     await dispatch(removeCustomer(formData, onDeleteSuccess, onError))
                                        // }


                                        if(type === 'Close'){
                                            const axiosPost = async () => {
                                                setLoading(true)
                                                await dispatch(change_Customer_Active(
                                                    {
                                                        customer: {customerId:currentRow.customerId,
                                                            customerName:currentRow.customerName,
                                                            isActive:'N',
                                                            ownerId:currentRow.ownerId,
                                                            userName:currentRow.ownerName}
                                                    },
                                                    onCloseSuccess, onError))
                                            }
                                            axiosPost().then()
                                        }

                                    }} autoFocus sx={{color: 'red'}} variant='outlined'>
                                        {t('Agree')}
                                    </MDButton>
                                </DialogActions>
                            </Dialog>

                            <Dialog
                                open={isCopyOpen || preloaded}
                                onClose={() => setIsCopyOpen(false)}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                                fullWidth
                                maxWidth={'sm'}
                                style={{ display: (isCopyOpen ? 'block' : 'none') }}

                            >
                                <DialogTitle id="alert-dialog-title">
                                    <div>{t("Are you sure?")}</div>
                                </DialogTitle>
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        {dragState.endCell?.row?.index - dragState.startCell?.row?.index <= 200 ?
                                            `${t('Do you want to copy')} ${dragState.endCell?.row?.index - dragState.startCell?.row?.index + 1} ${t('CustomerPage.Customer Names to the clipboard?')}` :
                                            t('You cannot copy more than 200 SKUs at a time')
                                        }
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <MDButton onClick={() => {
                                        setIsCopyOpen(false)
                                        setDragState({
                                            isDragging: false,
                                            startCell: null,
                                            endCell: null,
                                        })
                                    }}>
                                        {t('Cancel')}
                                    </MDButton>

                                    <MDButton
                                        disabled={dragState.endCell?.row?.index - dragState.startCell?.row?.index > 200}
                                        color={'primary'}
                                        variant={'contained'}
                                        data-tut="reactour_step3"
                                        onClick={() => {
                                            if(currentStep !== 0) return
                                            const startRowIndex = Math.min(dragState.startCell.row.index, dragState.endCell.row.index);
                                            const endRowIndex = Math.max(dragState.startCell.row.index, dragState.endCell.row.index);


                                            const kitSkuData = data.slice(startRowIndex, endRowIndex + 1)
                                                .map(row => row['customerName'])  // 假设'kitSku'是数据对象中对应列的键
                                                .join('\n');  // 使用换行符分隔，以便在复制到Excel等表格应用时形成单列

                                            let lines = kitSkuData.split('\n')
                                            let skus =  lines.filter(v=> v!=='')
                                            let jointString = skus.join(",")

                                            //     dispatch(onErrorAlert('The Input Cannot Exceed 200 SKUs'))

                                            setSkusInput(jointString)

                                            // 复制到剪切板
                                            navigator.clipboard.writeText(kitSkuData)
                                                .then(() => dispatch(onSuccessAlert(t('CustomerPage.Customer Names data copied to clipboard'))))
                                                .catch(err => dispatch(onErrorAlert((`${t('Failed to copy data')}: ${err}`))))
                                            setIsCopyOpen(false)
                                            setDragState({
                                                isDragging: false,
                                                startCell: null,
                                                endCell: null,
                                            })
                                        }}>
                                        {t('YES')}
                                    </MDButton>
                                </DialogActions>
                            </Dialog>
                            <Tour
                                steps={steps}
                                isOpen={tourOpen}
                                startAt={currentStep}
                                onRequestClose={closeTour}
                                getCurrentStep={(step) => setCurrentStep(step)}
                            />

                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
        </Fade>
        <CustomerImportDialog isImportOpen={isImportOpen} setIsImportOpen={setIsImportOpen} onSearchSuccess={onSearchSuccess} saveFormData={saveFormData} customerFilter={customerFilter} setLoading={setLoading}/>
    </React.Fragment>)
})

export default OwnerCustomer